<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <h2
    data-slot="section-header-title"
    :class="cn('flex flex-wrap items-center gap-3 text-xl font-semibold text-primal max-md:text-lg', props.class)"
  >
    <slot />
  </h2>
</template>
